import * as yup from "yup";
import i18next from "i18next";

export const validationSchemaDepartmentShort = yup.object().shape({
  city: yup.string().required(() => i18next.t("auth.validation.cityRequiredDepartment", { ns: "admin" })),
  street: yup.string().required(() => i18next.t("auth.validation.streetRequired", { ns: "admin" })),
  postalCode: yup
    .string()
    .required(() => i18next.t("auth.validation.postalCodeRequiredShort", { ns: "admin" }))
    .matches(/^[0-9, -]+$/, () => i18next.t("auth.validation.postalCodeFormat", { ns: "admin" }))
    .min(6, () => i18next.t("auth.validation.postalCodeFormat", { ns: "admin" }))
    .max(6, () => i18next.t("auth.validation.postalCodeFormat", { ns: "admin" })),
});

export const validationSchemaDepartment = yup.object().shape({
  email: yup
    .string()
    .email(() => i18next.t("auth.validation.emailInvalid", { ns: "admin" }))
    .required(() => i18next.t("auth.validation.emailRequired", { ns: "admin" }))
    .max(50),
  // pass: yup
  //   .string()
  //   .required("Żeby się zarejestrować musisz podać hasło")
  //   .min(6, "za krótkie hasło")
  //   .max(50),
  // pass2: yup
  //   .string()
  //   .required("Żeby się zarejestrować musisz podać hasło")
  //   .min(6, "za krótkie hasło")
  //   .max(50)
  //   .oneOf([yup.ref("pass")], "hasła muszą być takie same"),
  // phoneNumber: yup
  //   .string()
  //   .required("Żeby się zarejestrować musisz podać numer telefonu")
  //   .matches(/^[0-9]+$/, "niepoprawny numer telefonu")
  //   .min(9, "niepoprawny numer telefonu")
  //   .max(9, "niepoprawny numer telefonu"),
  city: yup
    .string()
    .required(() => i18next.t("auth.validation.cityRequiredDepartment", { ns: "admin" })),
  street: yup.string().required(() => i18next.t("auth.validation.streetRequired", { ns: "admin" })),
  postalCode: yup
    .string()
    .required(() => i18next.t("auth.validation.postalCodeRequiredDepartment", { ns: "admin" }))
    .matches(/^[0-9, -]+$/, () => i18next.t("auth.validation.postalCodeFormat", { ns: "admin" }))
    .min(6, () => i18next.t("auth.validation.postalCodeFormat", { ns: "admin" }))
    .max(6, () => i18next.t("auth.validation.postalCodeFormat", { ns: "admin" })),
  accept: yup
    .boolean()
    .oneOf([true], () => i18next.t("auth.validation.acceptTerms", { ns: "admin" })),
});

export const validationSchemaUser = yup.object().shape({
  email: yup
    .string()
    .email(() => i18next.t("auth.validation.emailInvalid", { ns: "admin" }))
    .required(() => i18next.t("auth.validation.emailRequired", { ns: "admin" }))
    .max(50),
  // pass: yup
  //   .string()
  //   .required("Żeby się zarejestrować musisz podać hasło")
  //   .min(6, "za krótkie hasło")
  //   .max(50),
  // pass2: yup
  //   .string()
  //   .required("Żeby się zarejestrować musisz podać hasło")
  //   .min(6, "za krótkie hasło")
  //   .max(50)
  //   .oneOf([yup.ref("pass")], "hasła muszą być takie same"),
  // phoneNumber: yup
  //   .string()
  //   .required("Żeby się zarejestrować musisz podać numer telefonu")
  //   .matches(/^[0-9]+$/, "niepoprawny numer telefonu")
  //   .min(9, "niepoprawny numer telefonu")
  //   .max(9, "niepoprawny numer telefonu"),
  department: yup
    .string()
    .required(() => i18next.t("auth.validation.departmentRequired", { ns: "admin" })),
});


export const validationSchemaUserShort = yup.object().shape({
  email: yup
    .string()
    .email(() => i18next.t("auth.validation.emailInvalid", { ns: "admin" }))
    .required(() => i18next.t("auth.validation.emailRequired", { ns: "admin" }))
    .max(50),
  // pass: yup
  //   .string()
  //   .required("Żeby się zarejestrować musisz podać hasło")
  //   .min(6, "za krótkie hasło")
  //   .max(50),
  // pass2: yup
  //   .string()
  //   .required("Żeby się zarejestrować musisz podać hasło")
  //   .min(6, "za krótkie hasło")
  //   .max(50)
  //   .oneOf([yup.ref("pass")], "hasła muszą być takie same"),
  // phoneNumber: yup
  //   .string()
  //   .required("Żeby się zarejestrować musisz podać numer telefonu")
  //   .matches(/^[0-9]+$/, "niepoprawny numer telefonu")
  //   .min(9, "niepoprawny numer telefonu")
  //   .max(9, "niepoprawny numer telefonu"),
});

export const validationSchemaUpdateUser = yup.object().shape({
  firstName: yup
    .string()
    .required(() => i18next.t("auth.validation.firstNameRequired", { ns: "admin" })),
  lastName: yup
    .string()
    .required(() => i18next.t("auth.validation.lastNameRequired", { ns: "admin" })),
  phoneNumber: yup
    .string()
    .required(() => i18next.t("auth.validation.phoneRequired", { ns: "admin" }))
    .matches(/^[0-9]{9}$/, () => i18next.t("auth.validation.phoneInvalid", { ns: "admin" })),
});

export const validationSchemaReceptionPlace = yup.object().shape({
  city: yup
    .string()
    .required(() => i18next.t("auth.validation.cityRequiredReceptionPlace", { ns: "admin" })),
  street: yup.string().required(() => i18next.t("auth.validation.streetRequiredReceptionPlace", { ns: "admin" })),
  postalCode: yup
    .string()
    .required(() => i18next.t("auth.validation.postalCodeRequiredReceptionPlace", { ns: "admin" }))
    .matches(/^[0-9, -]+$/, () => i18next.t("auth.validation.postalCodeFormatCompanyBasicInfo", { ns: "admin" }))
    .min(6, () => i18next.t("auth.validation.postalCodeFormatCompanyBasicInfo", { ns: "admin" }))
    .max(6, () => i18next.t("auth.validation.postalCodeFormatCompanyBasicInfo", { ns: "admin" })),
  phone: yup
    .string()
    .required(() => i18next.t("auth.validation.phoneRequired", { ns: "admin" }))
    .matches(/^[0-9]{9}$/, () => i18next.t("auth.validation.phoneInvalid", { ns: "admin" })),
  bdoNumber: yup
    .string()
    .required(() => i18next.t("auth.validation.bdoRequired", { ns: "admin" }))
    .matches(/^[0-9]+$/, () => i18next.t("auth.validation.bdoDigits", { ns: "admin" }))
    .nullable(),
  containerInactivityAlertDays: yup
    .number()
    .integer(() => i18next.t("auth.validation.integerRequired", { ns: "admin" }))
    .min(1, () => i18next.t("auth.validation.minValue1", { ns: "admin" }))
    .nullable()
    .transform((value, originalValue) => originalValue === '' ? null : value)
});

export const validationSchemaNonPolishReceptionPlace = yup.object().shape({
  city: yup
    .string()
    .required(() => i18next.t("auth.validation.cityRequiredReceptionPlace", { ns: "admin" })),
  street: yup.string().required(() => i18next.t("auth.validation.streetRequiredReceptionPlace", { ns: "admin" })),
  postalCode: yup
    .string()
    .required(() => i18next.t("auth.validation.postalCodeRequiredReceptionPlace", { ns: "admin" })),
    // .matches(/^[0-9, -]+$/, "Podaj poprawny kod pocztowy")
    // .min(6, "Podaj poprawny kod pocztowy")
    // .max(6, "Podaj poprawny kod pocztowy"),
  bdoNumber: yup
    .string()
    //.matches(/^[0-9]+$/, "Podaj cyfry")
    .nullable(),
    phone: yup
    .string()
    .matches(/^[0-9]{9}$/, () => i18next.t("auth.validation.phoneInvalid", { ns: "admin" })),
  containerInactivityAlertDays: yup
    .number()
    .integer(() => i18next.t("auth.validation.integerRequired", { ns: "admin" }))
    .min(1, () => i18next.t("auth.validation.minValue1", { ns: "admin" }))
    .nullable()
    .transform((value, originalValue) => originalValue === '' ? null : value)
});

// export const addPickUpPointSchemaShort = yup.object().shape({
//   city: yup
//     .string()
//     .required("uzupełnij miejscowość"),
//   street: yup.string().required("uzupełnij ulice"),
//   postalCode: yup
//     .string()
//     .required("uzupełnij kod pocztowy")
//     .matches(/^[0-9, -]+$/, "podaj poprawny kod pocztowy")
//     .min(6, "podaj poprawny kod pocztowy")
//     .max(6, "podaj poprawny kod pocztowy"),
// });

// export const editPickUpPointSchema = yup.object().shape({
//   city: yup
//     .string()
//     .required("uzupełnij miejscowość"),
//   street: yup.string().required("uzupełnij ulice"),
//   postalCode: yup
//     .string()
//     .required("uzupełnij kod pocztowy")
//     .matches(/^[0-9, -]+$/, "podaj poprawny kod pocztowy")
//     .min(6, "podaj poprawny kod pocztowy")
//     .max(6, "podaj poprawny kod pocztowy"),
// });
